import { CarService } from './services/car/car.service';
import { FormService } from './services/car/form.service';
import { FinalConfirmationComponent } from './pages/seller/car-form/components/final-confirmation/final-confirmation.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { SessionIdService } from './services/interceptors/session-id.service';
import { AuthService } from './shared/services/auth.service';
import { IonicStorageModule } from '@ionic/storage';
import { HTTP } from '@ionic-native/http/ngx';
import { HttpClientService } from './services/connections/http-client.service';
import { Iterable } from 'capacitor-iterable';
import { Intercom } from '@capacitor-community/intercom';
import { AnalyticsService } from './services/analytics/analytics.service';
import { TranslateModule, TranslateLoader, TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppService } from './services/app/app.service';
import { AppRate } from '@ionic-native/app-rate/ngx';
import { NativeStorage } from '@ionic-native/native-storage/ngx';
import { ImageUploadService } from './services/car/image-upload.service';
import { WebsocketService } from './services/connections/websocket.service';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
    declarations: [AppComponent, FinalConfirmationComponent],
    entryComponents: [],
    imports: [
        BrowserModule,
        IonicModule.forRoot({ swipeBackEnabled: false }),
        AppRoutingModule,
        BrowserAnimationsModule,
        HttpClientModule,
        IonicStorageModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        })
    ],
    providers: [
        StatusBar,
        SplashScreen,
        AuthService,
        AppService,
        HttpClientService,
        WebsocketService,
        FormService,
        CarService,
        HTTP,
        Iterable,
        Intercom,
        AnalyticsService,
        AppRate,
        NativeStorage,
        ImageUploadService,
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: SessionIdService, multi: true },
        HttpClient,
        TranslateService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
